import { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";

const CustomContextMenu = () => {
  const [visible, setVisible] = useState(false);
  const [position, setPosition] = useState({ x: 0, y: 0 });

  const handleContextMenu = useCallback((e: MouseEvent) => {
    e.preventDefault();
    setPosition({ x: e.clientX, y: e.clientY });
    setVisible(true);
  }, []);

  const handleClick = useCallback(() => {
    setVisible(false);
  }, []);

  useEffect(() => {
    document.addEventListener("contextmenu", handleContextMenu);
    document.addEventListener("click", handleClick);
    document.addEventListener("scroll", handleClick);
    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
      document.removeEventListener("click", handleClick);
      document.removeEventListener("scroll", handleClick);
    };
  }, [handleContextMenu, handleClick]);

  const handleCopy = () => {
    const selection = window.getSelection()?.toString();
    if (selection) navigator.clipboard.writeText(selection);
    setVisible(false);
  };

  const handlePaste = async () => {
    try {
      const text = await navigator.clipboard.readText();
      const el = document.activeElement as HTMLInputElement | HTMLTextAreaElement;
      if (el && ("value" in el)) {
        const start = el.selectionStart ?? el.value.length;
        const end = el.selectionEnd ?? el.value.length;
        const nativeInputValueSetter = Object.getOwnPropertyDescriptor(
          window.HTMLInputElement.prototype, "value"
        )?.set || Object.getOwnPropertyDescriptor(
          window.HTMLTextAreaElement.prototype, "value"
        )?.set;
        if (nativeInputValueSetter) {
          nativeInputValueSetter.call(el, el.value.slice(0, start) + text + el.value.slice(end));
          el.dispatchEvent(new Event("input", { bubbles: true }));
        }
      }
    } catch { /* clipboard not available */ }
    setVisible(false);
  };

  if (!visible) return null;

  const menuStyle: React.CSSProperties = {
    position: "fixed",
    top: position.y,
    left: position.x,
    zIndex: 99999,
  };

  return (
    <div style={menuStyle} className="min-w-[160px] rounded-md border bg-popover p-1 text-popover-foreground shadow-md animate-in fade-in-0 zoom-in-95">
      <button
        onClick={handleCopy}
        className="flex w-full items-center rounded-sm px-3 py-2 text-sm hover:bg-accent hover:text-accent-foreground cursor-default select-none"
      >
        Copy
      </button>
      <button
        onClick={handlePaste}
        className="flex w-full items-center rounded-sm px-3 py-2 text-sm hover:bg-accent hover:text-accent-foreground cursor-default select-none"
      >
        Paste
      </button>
      <div className="my-1 h-px bg-border -mx-1" />
      <DashboardLink onClose={() => setVisible(false)} />
    </div>
  );
};

const DashboardLink = ({ onClose }: { onClose: () => void }) => {
  const navigate = useNavigate();
  return (
    <button
      onClick={() => { onClose(); navigate("/dashboard"); }}
      className="flex w-full items-center rounded-sm px-3 py-2 text-sm hover:bg-accent hover:text-accent-foreground cursor-default select-none"
    >
      Dashboard
    </button>
  );
};

export default CustomContextMenu;
